import { Injectable } from '@angular/core';

export interface Questionario {
  ritiro_patente: string;
  // circolazione: string;
  copertura_esistente: string;
}

export interface VocePolizza {
  etichetta?: string;
  targa: string;
  tipoPatente: string;
  diaria: number;
  giorni: number;
  coperture: string[];
}

export interface DatiAnagrafici {
  ragioneSociale: string;
  nome: string;
  cognome: string;
  email: string;
  prefisso?: string;
  telefono?: string; // Nel primo step di inserimento dati il telefono è facoltativo
}

export interface DatiAzienda {
  ragioneSociale: string;
  tipoAzienda: string;
  partitaIva: string;
  indirizzoCompleto: string;
  indirizzo: string;
  comune: string;
  cap: string;
  provincia: string;
  civico: string;
}

export interface DatiLegale {
  codiceFiscale: string;
  cognome: string;
  nome: string;
  dataNascita: string;
  comuneNascita: string;
  genere: string;
  email: string;
  prefisso: string;
  telefono: string;
  indirizzoCompletoResidenza: string;
  indirizzoResidenza: string;
  comuneResidenza: string;
  capResidenza: string;
  provinciaResidenza: string;
  civicoResidenza: string;
}

export interface PreventivoResponseDTO {
  productId: string;
  importo: number;
  valuta: string;
}

export interface EmissioneResponseDTO {
  contractId: string;
  paymentId: string;
  externalPaymentId: string;
  redirectUrl: string;
}

export interface GetSignLinkResponseDTO {
  signLink: string | null;
}

export interface AskAIResponseDTO {
  reply: string | null;
}

@Injectable({
  providedIn: 'root'
})

export class Preventivo {
  private _referralCode?: string;

  private _questionario: Questionario | null = null;
  private _voci: VocePolizza[] = [];
  private _datiAnagrafici: DatiAnagrafici | null = null;
  private _datiAzienda: DatiAzienda | null = null;
  private _datiLegale: DatiLegale | null = null;

  private _preventivo: PreventivoResponseDTO | null = null;
  private emissioneResponse: EmissioneResponseDTO | null = null;

  private _massimale: number | null = null;
  private _privacyConsenso: boolean = false;
  private _marketingConsenso: boolean = false;

  private _metodoPagamento?: string;

  setReferral(referralCode: string) {
    this._referralCode = referralCode;
  }

  getReferral(): string | undefined {
    return this._referralCode;
  }

  setPrivacyConsenso(privacyConsenso: boolean) {
    this._privacyConsenso = privacyConsenso;
  }

  getPrivacyConsenso(): boolean {
    return this._privacyConsenso;
  }

  setMarketingConsenso(marketingConsenso: boolean) {
    this._marketingConsenso = marketingConsenso;
  }

  getMarketingConsenso(): boolean {
    return this._marketingConsenso;
  }

  setMassimale(massimale: number) {
    this._massimale = massimale;
  }

  getMassimale(): number | null {
    return this._massimale;
  }

  setQuestionario(q: Questionario) {
    this._questionario = q;
  }

  getQuestionario(): Questionario | null {
    return this._questionario;
  }

  getVoci(): VocePolizza[] {
    return this._voci;
  }

  addVoce(voce: VocePolizza) {
    this._voci.push(voce);
  }

  removeVoce(index: number) {
    this._voci.splice(index, 1);
  }

  clearVoci() {
    this._voci = [];
  }

  setDatiAnagrafici(dati: DatiAnagrafici) {
    this._datiAnagrafici = dati;
  }

  getDatiAnagrafici(): DatiAnagrafici | null {
    return this._datiAnagrafici;
  }

  setDatiAzienda(dati: DatiAzienda) {
    this._datiAzienda = dati;
  }

  getDatiAzienda(): DatiAzienda | null {
    return this._datiAzienda;
  }

  setDatiLegale(dati: DatiLegale) {
    this._datiLegale = dati;
  }

  getDatiLegale(): DatiLegale | null {
    return this._datiLegale;
  }

  setPreventivo(preventivo: PreventivoResponseDTO) {
    this._preventivo = preventivo;
  }

  getPreventivo(): PreventivoResponseDTO | null {
    return this._preventivo;
  }

  setEmissioneResponse(response: EmissioneResponseDTO) {
    this.emissioneResponse = response;
  }

  getEmissioneResponse(): EmissioneResponseDTO | null {
    return this.emissioneResponse;
  }

  setMetodoPagamento(metodoPagamento: string) {
    this._metodoPagamento = metodoPagamento;
  }

  getMetodoPagamento(): string | undefined {
    return this._metodoPagamento;
  }

  reset() {
    this._voci = [];
    this._datiAnagrafici = null;
    this._preventivo = null;
    this._datiAzienda = null;
    this._datiLegale = null;
  }

  constructor() { }
}
